export default __webpack_public_path__ + "static/media/logo_black_transparent_horiz.3c5b9f65.png";